import React from "react";

export default function ModalRegisterer() {
  return <div>ModalRegisterer</div>;
}
